export const REVENUE_DASHBOARD_CHANGE_TRACKING = {
  revenueDashboardTeamCreate: {
    source: 'revenue_dashboard.teams.create',
    id: 28001,
  },
  revenueDashboardTeamDelete: {
    source: 'revenue_dashboard.teams.delete',
    id: 28002,
  },
  revenueDashboardTeamUpdate: {
    source: 'revenue_dashboard.teams.update',
    id: 28003,
  },
  // Datadog-only: tags product feedback, never sent as a change-source header.
  revenueDashboardPageFeedback: {
    source: 'revenue_dashboard.page_feedback',
    id: 28900,
  },
} as const;
